import { CmsInformationConstants } from './cmsInformation.constants'
import { ICmsInformationState } from './cmsInformation.types'

export const initialCmsInformationState: ICmsInformationState = {
  cmsConditionCode: [],
  conditionCodeModifier: [],
  cmsTransportReason: [],
  ambulanceConditionIndication: [],
}

export function cmsInformationReducer(
  state: ICmsInformationState = initialCmsInformationState,
  action: any
): ICmsInformationState {
  switch (action.type) {
    case CmsInformationConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case CmsInformationConstants.SET_CMSCONDITIONCODE:
      return { ...state, cmsConditionCode: action.cmsConditionCode }
    case CmsInformationConstants.SET_CONDITIONCODEMODIFIER:
      return { ...state, conditionCodeModifier: action.conditionCodeModifier }
    case CmsInformationConstants.SET_CMSTRANSPORTREASON:
      return { ...state, cmsTransportReason: action.cmsTransportReason }
    case CmsInformationConstants.SET_AMBULANCECONDITIONINDICATION:
      return { ...state, ambulanceConditionIndication: action.ambulanceConditionIndication }
    case CmsInformationConstants.RESET_STATE:
      return { ...initialCmsInformationState }
    case CmsInformationConstants.SET_CMS_INFORMATION:
      return { ...state, ...action.cmsInformation }
    default:
      return state
  }
}
